import React from 'react';

interface InsightCardProps {
  insight: string;
}

const InsightCard: React.FC<InsightCardProps> = ({ insight }) => {
  return (
    <li style={{ 
      marginBottom: '0.75rem', 
      padding: '0.5rem 0',
      borderBottom: '1px solid #f7fafc',
      color: '#2d3748',
      lineHeight: '1.5'
    }}>
      {insight}
    </li>
  );
};

export default InsightCard;
